import { K1Information } from '@e3dc-react/icons'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Banner } from 'src/Components/banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundColor: theme.palette.secondary.light,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
    },
  },
  infoIcon: {
    fontSize: 30,
    color: theme.palette.secondary.main,
  },
}))

/** This is a banner that is shown if DPP Wallbox is enabled but Sunmode is disabled */
const SunModeDisabledBanner: React.FC = () => {
  const { classes } = useStyles()

  return (
    <Banner
      i18nKey="systemSettings.sunmode-disabled-banner.info-text"
      icon={<K1Information className={classes.infoIcon} />}
      containerStyle={classes.containerStyle}
      bannerKey={BannerKey.SunModeDisabledBanner}
      closeType={BannerCloseTypes.Temporary}
    />
  )
}

export default SunModeDisabledBanner
